import { START_GET_MENUS } from '../types';
    
export const getMenus = () => ({
    type: START_GET_MENUS
})